import { Store } from '@tanstack/react-store'

export const defaultBannerListState = {
  bannerSortOrder: { sortBy: { createDate: 'DESC' }, sortOrder: ['createDate'] },
}

export const bannerListStore = new Store(defaultBannerListState)

export const resetBannerList = () => {
  bannerListStore.setState(defaultBannerListState)
}
